import { Folder, ChevronRight } from "lucide-react";

const directoryNavigation = [
    {
        key: "/directory/users",
        icon: <Folder className="icon" />,
        label: "Directory",
        navigate: "/directory/users",
        expandIcon: ({ isOpen }) => (
            <ChevronRight
                className={`icon transition-transform duration-200 ${isOpen ? 'rotate-90' : ''}`}
            />
        ),
        children: [
            { key: "/directory/users", label: "Users", navigate: "/directory/users", },
            { key: "/directory/groups", label: "Groups", navigate: "/directory/groups", },
            { key: "/directory/activeDirectory", label: "Active Directory", navigate: "/directory/activeDirectory", },
            { key: "/pam/settings/users", label: "Users & Access", navigate: "/pam/settings/users", },
        ]
    }
];


export default directoryNavigation;